import React from 'react';
import PropTypes from 'prop-types';

export default function Icon({ name, className, onClick }) {
  return (
    <svg className={`icon icon-${name} ${className}`} onClick={onClick}>
      <use xlinkHref={`#icon-${name}`} />
    </svg>
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};

Icon.defaultProps = {
  className: '',
  onClick: () => {}
};



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js